// extracted by mini-css-extract-plugin
export default {"output":"output_output__UTSPP","plaintext":"output_plaintext__Sajld"};